
import React from 'react';
import { TableHead } from '@/components/ui/table';
import { ArrowUp, ArrowDown } from 'lucide-react';

interface ReportsSortableHeaderProps {
  field: string;
  label: string;
  currentSortField: string;
  sortDirection: 'asc' | 'desc';
  onSort: (field: string) => void;
}

export const ReportsSortableHeader: React.FC<ReportsSortableHeaderProps> = ({
  field,
  label,
  currentSortField,
  sortDirection,
  onSort
}) => {
  const isSorted = currentSortField === field;
  
  return (
    <TableHead 
      className="cursor-pointer hover:bg-gray-100 transition-colors"
      onClick={() => onSort(field)}
    >
      <div className="flex items-center gap-1">
        {label}
        {isSorted && (
          sortDirection === 'asc' ? 
            <ArrowUp className="h-4 w-4" /> : 
            <ArrowDown className="h-4 w-4" />
        )}
      </div>
    </TableHead>
  );
};
